import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalErrorHandler } from '@schoolbelle/api/schoolbelle';
import { LoadingService } from '@schoolbelle/common/loading';
import { LocationService } from '@schoolbelle/common/location';
import { TranslationService } from '@schoolbelle/common/translation';
import { forEach } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  status:number;
  message:string;
  alreadySent:boolean = false;
  error:Error;
  constructor (
    protected route:ActivatedRoute,
    protected router:Router,
    protected location:LocationService,
    protected globalErrorHandler:GlobalErrorHandler,
    protected loading:LoadingService,
    protected toastr:ToastrService,
    protected elementRef:ElementRef,
    protected translation:TranslationService,
  ) {}
  ngOnInit() {


    const {status, message} = this.route.snapshot.queryParams;
    this.status = status ? Number(status) : null;
    this.message = message;

    this.alreadySent = this.globalErrorHandler.permissionGranted;

    // test
    // this.globalErrorHandler.lastError = new Error('Error here');
    // test
    this.error = this.globalErrorHandler.lastError;

  }

  getMessage (status:number) {
    switch (status) {
      case 401 :
        return 'Permission has been expired or is not granted.';
    }
  }
  retry () {
    const {redirect_uri} = this.route.snapshot.queryParams;
    this.router.navigateByUrl(redirect_uri);
  }
  goBack () {
    this.location.back();
  }
  send () {
    const subscription = this.globalErrorHandler.reportError().subscribe(()=>{
      this.toastr.success(this.translation.get('error-report-succeeded'));
    });
    this.loading.open({busy:subscription});

  }
  ngAfterViewInit(): void {
    forEach(this.elementRef.nativeElement.querySelectorAll("div[translation-text]"), (el) => this.translation.set(el.id,  el.attributes["translation-text"].value))
  }    


}
